import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import useResponsive from '../../hooks/useResponsive';
import DashboardNavbar from './DashboardNavbar';
import DashboardSidebar from './DashboardSidebar';

const APP_BAR_MOBILE  = 64;
const APP_BAR_DESKTOP = 72;

// ── Very light, neutral page background ─────────────────────────────────────
// #F8FAFC is almost white with a barely-there cool tint
// Cards (white) pop clearly against it — no harsh colors at all
const RootStyle = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden',
  background: '#F8FAFC',
});

const MainStyle = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: APP_BAR_MOBILE + 24,
  paddingBottom: theme.spacing(10),
  paddingLeft: theme.spacing(3),
  paddingRight: theme.spacing(3),
  [theme.breakpoints.up('lg')]: {
    paddingTop: APP_BAR_DESKTOP + 24,
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
}));

export default function DashboardLayout() {
  const [open, setOpen] = useState(false);          // mobile temporary drawer
  const [collapsed, setCollapsed] = useState(false); // desktop persistent hide
  const isDesktop = useResponsive('up', 'lg');
  const handleToggleSidebar = () =>
    isDesktop ? setCollapsed((v) => !v) : setOpen(true);

  return (
    <RootStyle>
      <DashboardNavbar onToggleSidebar={handleToggleSidebar} collapsed={collapsed} />
      <DashboardSidebar isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} collapsed={collapsed} />
      <MainStyle>
        <Outlet />
      </MainStyle>
    </RootStyle>
  );
}
